let getExperienceType = () => {
    let x = globalThis.innerWidth
    let y

    if (x < 768) {
        y = 'mobile'
    } else if (x < 992) {
        y = 'tablet'
    } else {
        y = 'desktop'
    }

    return y
}

let getRadUIVersion = () => {
    let x = globalThis.innerWidth
    let y

    if (x < 768) {
        y = 'mobile'
    } else if (x < 992) {
        y = 'tablet'
    } else {
        y = 'pc'
    }

    return 'ui:rad:' + y
}

let getPageDomain = () => {
    const hostname = globalThis?.location?.hostname || ''
    return hostname.includes('www.ford') ? 'https://www.ford.com' : 'https://wwwqa.ford.com'
}

export const docUploadAnalytics = {
    constants: {
        pageNameNoVehicle: 'fv:dynamic manage:doc upload',
        pageID: 'dynamic manage',
        contentSubType: 'doc upload',
        pTemplate: 'none',
        linkType: 'cta',
        clickAction: 'click',
        satelliteTrackId: 'ecommInternalCtaClick',
        errorSatelliteTrackId: 'moduleErrorCtaClick',
        loginStatus: 'logged in',
        pageName: 'fv:dynamic manage:doc upload',
        // siteSection:"<ch>",
        // hierarchy:"<h1>",
        // userLanguage:"<v4>",
        // client:"<v14>",
        // site:"<v15>",
        tool: 'doc upload start',
        radUIVersion: getRadUIVersion(),
        pageDomain: getPageDomain(),
        pageType: 'fv:dynamic manage',
        experienceType: getExperienceType()
    },
    prepareDataLayer: function (value) {
        return {
            page: {
                ...globalThis?.digitaldata?.page,
                pageDomain: `${this.constants.pageDomain}`,
                pageType: `${this.constants.pageType}`,
                experienceType: `${this.constants.experienceType}`,
                pageNameNoVehicle: `${this.constants.pageNameNoVehicle}`
            },
            onclick: {
                onclickLinkName: `${this.constants.pageNameNoVehicle}:${this.constants.linkType}:${value}:${this.constants.nameplate}`,
                onclick: `${this.constants.pageID}:${this.constants.contentSubType}:${this.constants.linkType} ${this.constants.clickAction}:${value}`,
                contentType: `${this.constants.pageID}:${this.constants.pTemplate}:${this.constants.clickAction}`,
                contentSubType: `${this.constants.contentSubType}`
            }
        }
    },
    backToDM: function () {
        return this.prepareDataLayer('back to dynamic manage')
    },
    uploadDoc: function (documentName) {
        return this.prepareDataLayer(`${documentName}:upload`)
    },
    cancel: function (documentName) {
        return this.prepareDataLayer(`${documentName}:cancel edit`)
    },
    delete: function (documentName) {
        return this.prepareDataLayer(`${documentName}:delete doc`)
    },
    confirmDelete: function (documentName) {
        return this.prepareDataLayer(`${documentName}:delete doc confirm`)
    },
    edit: function (documentName) {
        return this.prepareDataLayer(`${documentName}:edit doc`)
    },
    done: function (documentName) {
        return this.prepareDataLayer(`${documentName}:done`)
    },
    error: function (errorMessage) {
        const dataLayer = this.prepareDataLayer('error states')
        return {
            ...dataLayer,
            user: {
                errorTracking: errorMessage
            }
        }
    },
    track: function (eventName, value = '') {
        value = value.toLowerCase()
        const updatedDataLayer = this[eventName](value)
        globalThis.digitaldata = globalThis.digitaldata || {}
        if (globalThis?.digitaldata?.user?.errorTracking) {
            delete globalThis.digitaldata.user.errorTracking
        }
        globalThis.digitaldata = {
            ...globalThis.digitaldata,
            ...updatedDataLayer
        }
        const satelliteTrackId = updatedDataLayer?.user?.errorTracking
            ? this.constants.errorSatelliteTrackId
            : this.constants.satelliteTrackId
        if (globalThis?._satellite) {
            globalThis._satellite.track(satelliteTrackId)
        }
    }
}
